// extracted by mini-css-extract-plugin
export const sectionRoot = "K_bF";
export const contentRoot = "K_bH";
export const stepRoot = "K_bJ";
export const stepIcon = "K_bK";
export const stepTitle = "K_bL";